import { Link, NavLink } from 'react-router-dom'
import { UserMenuContent } from './UserMenuContent'
import { useAuth } from '@/hooks/useAuth'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar'
import { NotificationBell } from './NotificationBell'
import { athleteTabs } from './athleteNavigation'
import { cn } from '@/lib/utils'

/** Logo, the desktop nav, notifications and the avatar menu. Phones navigate with BottomNav. */
const Header = () => {
  const { athlete } = useAuth()
  return (
    <header className="sticky top-0 z-20 w-full border-b border-border bg-card">
      <div className="mx-auto flex h-14 max-w-[1100px] items-center gap-3 px-4 md:px-6">
        <Link to="/" className="flex items-center" aria-label="Home">
          <img
            src="https://adthlete.us-iad-1.linodeobjects.com/public/athios-logo-black.png"
            alt="Athios"
            className="h-6 md:h-7"
          />
        </Link>

        <nav className="ml-6 hidden items-center gap-1 md:flex" aria-label="Main">
            {athleteTabs.map((t) => (
              <NavLink
                key={t.path}
                to={t.path}
                end={t.end}
                className={({ isActive }) =>
                  cn(
                    'rounded-full px-3.5 py-1.5 text-sm font-semibold',
                    isActive ? 'bg-[#C0FD72] text-[#0F172A]' : 'text-foreground hover:bg-muted',
                  )
                }
              >
                {t.label}
              </NavLink>
            ))}
          </nav>

        <div className="ml-auto flex items-center gap-1">
          <NotificationBell />
          <DropdownMenu>
            <DropdownMenuTrigger
              className="rounded-full focus:outline-hidden"
              aria-label="Account"
            >
              <Avatar className="h-8 w-8 border border-border">
                <AvatarImage src={athlete?.avatar} alt="" />
                <AvatarFallback className="bg-muted text-xs text-foreground">
                  {athlete?.name?.charAt(0) || 'A'}
                </AvatarFallback>
              </Avatar>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="end"
              className="w-60 rounded-2xl border-border bg-card p-1.5"
            >
              <UserMenuContent showUserInfo />
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  )
}
export default Header
